import * as React from 'react';
import './Loader.css';

export default function Loader() {
  return (
    <div className="loader">
      <span>{'{'}</span>
      <span>{'}'}</span>
    </div>
  )
}